import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { MemberService } from "../services/member.service";
import { SortableComponent } from '../../core/sortable/sortable.component';
import { RouteHelperService } from '../../core/services/route-helper.service';
import { PageParamStorageService } from '../../core/services/page-param-storage.service';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'ch-members-for-verification',
  templateUrl: './members-for-verification.component.html',
  styleUrls: ['./members-for-verification.component.css'],
})
export class MembersForVerificationComponent implements OnInit, OnDestroy {
  public items = [];
  public totalItems;
  public pageParams: any = {};
  public loading: boolean;

  constructor(
    private memberService: MemberService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private routeHelperService: RouteHelperService,
    private pageParamStorageService: PageParamStorageService,
    private titleService: Title,
  ) {}

  ngOnInit() {
    this.titleService.setTitle(`Members Pending Verification | CODE Hospitality CMS`);
    this.activatedRoute.queryParamMap
      .map((params: Params) => params.params)
      .subscribe(params => {
        if (Object.keys(params).length === 0 && this.pageParamStorageService.pageParams) {
          params = this.pageParamStorageService.pageParams;
          this.queryParams(params);
        }
        this.pageParams = this.routeHelperService.getValidatedParams(params);
        this.loadItems(this.pageParams);
        this.pageParamStorageService.pageParams = this.pageParams;
      });
  }

  ngOnDestroy(): void {
    this.titleService.setTitle(`CODE Hospitality CMS`);
  }

  public onSort(data) {
    this.queryParams({
      sortBy: data.column,
      sortOrder: data.order,
    });
  }

  public onPageChanged(page) {
    this.queryParams({
      pageNumber: page.pageNumber,
      pageSize: page.pageSize,
    });
  }

  private queryParams(params) {
    const result = this.routeHelperService.queryParams(params, this.pageParams);
    this.router.navigate([], { queryParams: result });
  }

  private loadItems(data) {
    this.loading = true;
    this.memberService.getForVerification(data).subscribe(result => {
      const jsonData = result.json();
      this.items = jsonData.items;
      this.totalItems = jsonData.totalItems;
      this.loading = false;
    });
  }
}



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/member/members-for-verification/members-for-verification.component.ts